export type MyOutlookAugLoopEnvironment = "host-default" | "local" | "dogfood" | "msit";

export type MyOutlookAugLoopTarget = {
    readonly environment: "dogfood";
    readonly dogfoodRegion?: string;
} | {
    readonly environment: Exclude<MyOutlookAugLoopEnvironment, "dogfood">;
    readonly dogfoodRegion?: never;
};

const AUGLOOP_ENVIRONMENTS: readonly string[] = ["host-default", "local", "dogfood", "msit"];
const DOGFOOD_REGION_PATTERN = /^[a-z0-9]+-da\d{2}$/;

export function isMyOutlookAugLoopEnvironment(value: string): value is MyOutlookAugLoopEnvironment {
    return AUGLOOP_ENVIRONMENTS.includes(value);
}

export function isMyOutlookDogfoodRegion(value: string): boolean {
    return DOGFOOD_REGION_PATTERN.test(value);
}
